module.exports = __webpack_public_path__ + "img/img_proposal.9c689b5e.jpg";